<template lang="html">
	<div class="chat-wrapper" >
		<div class="chat-sidebar">
			<!-- start sidebar body -->
			<div class="chat-sidebar-body">
				<div class="flex-fill pd-y-20 pd-x-10">
					<div class="d-flex align-items-center justify-content-between pd-x-10 mg-b-10">
						<span class="tx-12 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1">Department</span>
					</div>
					<b-menu>
						<b-menu-list>
							<b-menu-item :expanded="true" v-for="form in chg_dept_a" :key="form.id" :label="form.kor" :id="form.id" icon="home" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
								<b-menu-item v-for="user in user_a" v-if="user.team[0] === form.id" :key="user.id" :id="user.id" icon="account" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
									<template slot="label" slot-scope="props">
										<b-dropdown aria-role="list">
											<span slot='trigger' class=''>{{user.userName}}<span class='tx-10 tx-color-03'>&nbsp;&nbsp;{{user.position.codeName}}[{{user.official.codeName}}]</span></span>
											<b-dropdown-item aria-role="listitem" class="tx-10" @click='addReview(user.id, form.id)'>Review</b-dropdown-item>
											<b-dropdown-item aria-role="listitem" class="tx-10" @click='addApproval(user.id, form.id)'>Approval</b-dropdown-item>
										</b-dropdown>
									</template>
								</b-menu-item>
								<b-menu-item v-if="form.child.length > 0" v-for="form1 in form.child" :key="form1.id" :label="form1.kor" icon="view-sequential" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
									<b-menu-item v-for="user in user_a" v-if="user.team[0] === form1.id" :key="user.id" :id="user.id" @click="" icon="account" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
										<template slot="label" slot-scope="props">
											<b-dropdown aria-role="list">
												<span slot='trigger' class=''>{{user.userName}}<span class='tx-10 tx-color-03'>&nbsp;&nbsp;{{user.position.codeName}}[{{user.official.codeName}}]</span></span>
												<b-dropdown-item aria-role="listitem" class="tx-10" @click='addReview(user.id, form1.id)'>Review</b-dropdown-item>
												<b-dropdown-item aria-role="listitem" class="tx-10" @click='addApproval(user.id, form1.id)'>Approval</b-dropdown-item>
											</b-dropdown>
										</template>
									</b-menu-item>
									<b-menu-item v-if="form1.child.length > 0" v-for="form2 in form1.child" :key="form2.id" :label="form2.kor" icon="view-sequential" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
										<b-menu-item v-for="user in user_a" v-if="user.team[0] === form2.id" :key="user.id" :id="user.id" @click="" icon="account" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
											<template slot="label" slot-scope="props">
												<b-dropdown aria-role="list">
													<span slot='trigger' class=''>{{user.userName}}<span class='tx-10 tx-color-03'>&nbsp;&nbsp;{{user.position.codeName}}[{{user.official.codeName}}]</span></span>
													<b-dropdown-item aria-role="listitem" class="tx-10" @click='addReview(user.id, form2.id)'>Review</b-dropdown-item>
													<b-dropdown-item aria-role="listitem" class="tx-10" @click='addApproval(user.id, form2.id)'>Approval</b-dropdown-item>
												</b-dropdown>
											</template>
										</b-menu-item>
										<b-menu-item v-if="form2.child.length > 0" v-for="form3 in form2.child" :key="form3.id" :label="form3.kor" icon="view-sequential" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
											<b-menu-item v-for="user in user_a" v-if="user.team[0] === form3.id" :key="user.id" :id="user.id" @click="" icon="account" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
												<template slot="label" slot-scope="props">
													<b-dropdown aria-role="list">
														<span slot='trigger' class=''>{{user.userName}}<span class='tx-10 tx-color-03'>&nbsp;&nbsp;{{user.position.codeName}}[{{user.official.codeName}}]</span></span>
														<b-dropdown-item aria-role="listitem" class="tx-10" @click='addReview(user.id, form3.id)'>Review</b-dropdown-item>
														<b-dropdown-item aria-role="listitem" class="tx-10" @click='addApproval(user.id, form3.id)'>Approval</b-dropdown-item>
													</b-dropdown>
												</template>
											</b-menu-item>
										</b-menu-item>
									</b-menu-item>
								</b-menu-item>
							</b-menu-item>
						</b-menu-list>
					</b-menu>
				</div>
			</div><!-- chat-sidebar-body -->
		</div><!-- chat-sidebar -->

		<div class="chat-content">
			<div class="chat-content-body t-0">
				<div class="col-xl-3-1 mg-t-10 pr-0 pl-0 float-left">
					<div class="card card-profile">
						<div class="card-body tx-13 pd-0-f app-top-radius">
							<div class="mt-0">
								<h6 class="mt-2 text-uppercase">request</h6>
							</div>
						</div><!-- card-body -->
						<div class="card-body tx-13">
							<div class="mt-0" >
								<h5>{{request_user.userName}}</h5>
								<p class="mb-0">{{request_user.teamName}}</p>
								<p>{{request_user.position.codeName}}</p>
								<button class="btn btn-block a-btn-border" disabled>Request</button>
								<p class="mb-0 pd-b-2-f">2019-12-18</p>
							</div>
						</div><!-- card-body -->
					</div><!-- card -->
				</div><!-- col -->
				<div class="col-xl-3-1 mg-t-10 pr-0 pl-0 float-left" v-for="form in reivew_a">
					<div class="card card-profile">
						<div class="card-body tx-13 pd-0-f app-top-radius">
							<div class="mt-0">
								<h6 class="mt-2 text-uppercase">review</h6>
							</div>
						</div><!-- card-body -->
						<div class="card-body tx-13">
							<div class="mt-0">
								<h5>{{form.userName}}&nbsp;</h5>
								<p class="mb-0">{{form.deptkor}}&nbsp;</p>
								<p>{{form.positionName}}&nbsp;</p>
								<button v-if="form.apprid.length > 0" class="btn btn-block btn-white" @click="confirmApproval(form.userid, form.apprid, form.gid)">Approval&nbsp;</button>
								<button v-else-if="form.userid.length > 0" class="btn btn-block btn-white" @click="delApproval(form.userid, form.apprid, form.gid, 'R')">Cancel&nbsp;</button>
								<button v-else class="btn btn-block a-btn-border" disabled>{{form.apprid}}&nbsp;</button>
								<p class="mb-0 pd-b-2-f">{{form.apprdate}}&nbsp;</p>
							</div>
						</div><!-- card-body -->
					</div><!-- card -->
				</div><!-- col -->
				<div class="col-xl-3-1 mg-t-10 pr-0 pl-0 float-left" v-for="form in approval_a">
					<div class="card card-profile">
						<div class="card-body tx-13 pd-0-f app-top-radius">
							<div class="mt-0">
								<h6 class="mt-2 text-uppercase">approval</h6>
							</div>
						</div><!-- card-body -->
						<div class="card-body tx-13">
							<div class="mt-0">
								<h5>{{form.userName}}&nbsp;</h5>
								<p class="mb-0">{{form.deptkor}}&nbsp;</p>
								<p>{{form.positionName}}&nbsp;</p>
								<button v-if="form.apprid.length > 0" class="btn btn-block btn-white" @click="confirmApproval(form.userid, form.apprid, form.gid)">Approval&nbsp;</button>
								<button v-else-if="form.userid.length > 0" class="btn btn-block btn-white" @click="delApproval(form.userid, form.apprid, form.gid, 'A')">Cancel&nbsp;</button>
								<button v-else class="btn btn-block a-btn-border" disabled>{{form.apprid}}&nbsp;</button>
								<p class="mb-0 pd-b-2-f">{{form.apprdate}}&nbsp;</p>
							</div>
						</div><!-- card-body -->
					</div><!-- card -->
				</div><!-- col -->
			</div><!-- chat-content-body -->
		</div><!-- chat-content -->
	</div><!-- chat-wrapper -->
</template>
<script>
	//(화사 정보에 approval used 인 경우에만 사용)
	import {bus} from '../../main';

	export default {
		data() {
			return {
				isActive: true,
				department_a: [], // 부서정보
				chg_dept_a: [], // tree 구조 부서 정보 변경
				user_a: [], // 사용자 정보 
				dept_user_a: [], // 선택된 부서 별 사용자 정보
				approval_a: [
					{userid: '', userName: '', positionName: '', deptkor: '', depteng: '' , apprid: '', apprdate: '', gid: '', sort: ''},
				], // 결재 정보 (있는 경우)
				reivew_a: [
					{userid: '', userName: '', positionName: '', deptkor: '', depteng: '' , apprid: '', apprdate: '', gid: '', sort: ''},
					{userid: '', userName: '', positionName: '', deptkor: '', depteng: '' , apprid: '', apprdate: '', gid: '', sort: ''},
					{userid: '', userName: '', positionName: '', deptkor: '', depteng: '' , apprid: '', apprdate: '', gid: '', sort: ''}
				], // 검토 정보 (있는 경우)
				companyId: '',
				request_user: [],
			}
		},
		beforeDestroy(){
			bus.$off('companyid');
			bus.$off('userinfo');
		},
		created(){
			bus.$on('companyid', (data)=>{
				this.classifyDepartment(data);
				this.companyId = data;
			});
			bus.$on('userinfo', (data)=>{
				this.classifyUser(this.companyId, data.id);
			});

		},
		mounted() {
		},
		components: {
		},
		methods: {
			/*
			* Add Review Data
			*/
			async addReview(userid, deptid){
				let bool = false;
				// 동일 결재 인물 확인
				if(this.reivew_a.length > 0){
					this.reivew_a.some(a=>{
						if(a.userid === userid) {
							alert('Registered contact person.');
							bool = true;
							return false;
						}
					})
				}
				// 검토(review) 3명 이상 못하도록 설정
				// if(this.reivew_a.length >= 3) bool = true;
				// 결재 배열에 추가
				if(!bool){
					// {userid: '', userName: '', positionName: '', deptkor: '', depteng: '' , apprid: '', apprdate: '', gid: '', sort: ''} gid는 결재 그룹(detail id 임)
					this.user_a.some(a=>{
						if(userid === a.id && deptid === a.team[0]){
							let info = []
							info.userid = a.id;
							info.userName = a.userName;
							info.positionName = a.position.codeName;
							info.apprdate = '';
							info.apprid = '';
							info.gid = '';
							this.department_a.some(b=>{
								if(deptid === b.id){
									if(Number(b.depth) === 0){
										info.deptkor = '';
										info.depteng = '';
									}else{
										info.deptkor = b.kor;
										info.depteng = b.eng;
									}
								}
							});
							this.reivew_a.some((c,d)=>{
								if(c.userid.length === 0){
									this.reivew_a.splice(d,1,info);
									return true;
								}
							});
							
						}
					});
				}
			},
			/*
			* Add Approval Data
			*/
			async addApproval(userid, deptid){
				let bool = false;
				// 동일 결재 인물 확인
				if(this.approval_a[0].userid.length > 0){
					alert('An approval representative exists.');
					bool = true;
				}
				// 결재(approval) 1명 이상 못하도록 설정
				// if(this.approval_a.length > 0) bool = true;
				// 결재 배열에 추가
				if(!bool){
					// {userid: '', userName: '', positionName: '', deptkor: '', depteng: '' , apprid: '', apprdate: '', gid: '', sort: ''} gid는 결재 그룹(detail id 임)
					this.user_a.some(a=>{
						if(userid === a.id && deptid === a.team[0]){
							let info = []
							info.userid = a.id;
							info.userName = a.userName;
							info.positionName = a.position.codeName;
							info.apprdate = '';
							info.apprid = '';
							info.gid = '';
							this.department_a.some(b=>{
								if(deptid === b.id){
									if(Number(b.depth) === 0){
										info.deptkor = '';
										info.depteng = '';
									}else{
										info.deptkor = b.kor;
										info.depteng = b.eng;
									}
								}
							});
							this.approval_a.some((c,d)=>{
								if(c.userid.length === 0){
									this.approval_a.splice(d,1,info);
									return true;
								}
							});
						}
					});
				}
			},
			/*
			* Data Delete Approval Info
			*/
			async delApproval(userid, apprid, gid, gubun){
				if(gubun =='R'){
					this.reivew_a.some((a,b)=>{
						if(a.userid === userid){
							this.reivew_a.splice(b,1,{userid: '', userName: '', positionName: '', deptkor: '', depteng: '' , apprid: '', apprdate: '', gid: '', sort: ''})
						}
					});
				}else{
					this.approval_a.some((a,b)=>{
						if(a.userid === userid){
							this.approval_a.splice(b,1,{userid: '', userName: '', positionName: '', deptkor: '', depteng: '' , apprid: '', apprdate: '', gid: '', sort: ''})
						}
					});
				}
			},
			/*
			* Load Data User Info
			*/
			async userInfo(deptid, depth){
				let call_user_a = [];
				let dept_a = [];
				if(Number(depth)===0){
					call_user_a = this.user_a;
				}else{
					this.user_a.some((a)=>{ // 선택한 위치의 팀원 정보 push
						if(a.team.length > 1){
							a.team.forEach(b=>{
								if(b === deptid) call_user_a.push(a);
							});
						}else{
							if(a.team[0] === deptid) call_user_a.push(a);
						}
					});
					this.department_a.some(a=>{ // 선택한 위치의 하위 팀 정보 생성
						if(a.parentId === deptid){
							dept_a.push(a.id);
							this.department_a.some(b=>{
								if(b.parentId === a.id){
									dept_a.push(b.id)
								}
							})
						}
					});
					this.user_a.some((a)=>{ // 선택한 위치의 하위 팀 정보 push
						dept_a.some(b=>{
							if(a.team.length > 1){
								a.team.some(c=>{
									if(b===c) call_user_a.push(a);
								});
							}else{
								if(b===a.team[0]) call_user_a.push(a);
							}
						});
					});
				}
				this.dept_user_a = call_user_a;
			},

			/*
			* Load Data User Headers
			*/
			async classifyUser(companyid, userid){
				this.user_a = [];
				var params = { companyId: companyid };
				var request = { params: params };
				await this.$axios.get(this.$apiHost + "/users/getUser", request)
				.then(res => {
					this.user_a = res.data;
					res.data.some(a=>{
						if(userid == a.id){
							this.request_user = a;
							return true;
						}
					});
					this.department_a.some(a=>{
						if(this.request_user.team[0] == a.id){
							this.request_user.teamName = a.kor;
							return true;
						}
					});
				}).catch(error => {throw error;});
			},

			/*
			* Load Data Department Headers & depth type array setting
			*/
			async classifyDepartment(companyid){
				this.department_a = [];
				var params = { companyId: companyid };
				var request = { params: params };
				await this.$axios.get(this.$apiHost + "/depts", request)
				.then(res => {
					this.department_a = res.data;
				}).catch(error => {throw error;});
				let dept_a = [];
				this.department_a.forEach(a=>{
					a.child = [];
					if(Number(a.depth) === 0){
						dept_a.push(a);
					}else if(Number(a.depth) === 10){
						if(dept_a[0].id === a.parentId){
							dept_a[0].child.push(a);
						}
					}else if(Number(a.depth) === 100){
						dept_a[0].child.forEach((b, c)=>{
							if(b.id === a.parentId){
								dept_a[0].child[c].child.push(a);
							}
						});
					}else if(Number(a.depth) === 1000){
						dept_a[0].child.forEach((b, c)=>{
							b.child.forEach((d, e)=>{
								if(d.id === a.parentId){
									dept_a[0].child[c].child[e].child.push(a);
								}
							});
						});
					}
				});
				this.chg_dept_a = dept_a;
			},
		},
		computed: {
		},
		watch: {
		},
	}
</script>


// WEBPACK FOOTER //
// src/views/Common/Approval.vue